import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReportTemplateData } from '../models/api-models';
import { getLatestReportTemplates, isReportTemplatesLoading } from '../store/settings/selectors';
import { loadReportTemplates } from '../store/settings/actions';

export interface ReportTemplatesHook {
    templates: ReportTemplateData[];
    loading: boolean;
}

export const useReportTemplates = (): ReportTemplatesHook => {
    const dispatch = useDispatch();
    const templates = useSelector(getLatestReportTemplates) ?? [];
    const loading = useSelector(isReportTemplatesLoading);

    useEffect(() => {
        dispatch(loadReportTemplates());
    }, [dispatch]);

    return { templates, loading };
};
